import {
    createMobilePairingSocketClient,
    configureMobilePairingTransport,
    attachMobilePairingInboundToDispatch,
} from '@pendo/services/MobilePairing';

const urlParams = new URLSearchParams(window.location.search);
const setupKey = urlParams.get('setupKey');

export const mobilePairingSocketClient = createMobilePairingSocketClient({
    host: window.location.host,
    setupKey,
});

configureMobilePairingTransport({
    connect: () => mobilePairingSocketClient.connect(),
    disconnect: () => mobilePairingSocketClient.disconnect(),
    emit: (eventName, payload) => mobilePairingSocketClient.emit(eventName, payload),
});

export function mobilePairingSocketPlugin (store) {
    attachMobilePairingInboundToDispatch(store.dispatch, mobilePairingSocketClient, { namespace: 'devicesConnection' });
}
